

export default class Gallery {
    constructor() {
        this.images = [];
        this.selectedImageIndex = -1;
    }

    /*
    addImage(imageUrl, title, description) {
        this.images.push({
            imageUrl: imageUrl,
            title: title,
            description: description
        });
    }
    */

    addImage(props) {
        this.images.push(props);
        return this.images;
    }

    imageSetProperty(index, property, value) {
        if (index >= 0 && index < this.images.length) {
            return this.images[index][property] = value;
        }
        return false;
    }


    removeImage(index) {
        if (index >= 0 && index < this.images.length) {
            this.images.splice(index, 1);
            if (index === this.selectedImageIndex) {
                this.selectedImageIndex = -1; // Reset selected image if the removed image was selected
            } else if (index < this.selectedImageIndex) {
                this.selectedImageIndex--; // Adjust selected image index if it was after the removed image
            }
        }
    }

    getImage(index) {
        if (index >= 0 && index < this.images.length) {
            return this.images[index];
        }
        return null;
    }

    getImageByProperty(propertyName, propertyValue) {
        const foundImage = this.images.find(image => image[propertyName] === propertyValue);
        return foundImage || null;
    }

    getImages() {
        return this.images;
    }

    getImageCount() {
        return this.images.length;
    }

    getSelectedImage() {
        if (this.selectedImageIndex >= 0 && this.selectedImageIndex < this.images.length) {
            return this.images[this.selectedImageIndex];
        }
        return false;
    }
    getSelectedImageIndex() {
        if (this.selectedImageIndex >= 0 && this.selectedImageIndex < this.images.length) {
            return this.selectedImageIndex
        }
        return false;
    }

    setSelectedImage(index) {
        if(!index) this.selectedImage = false;
        if (index >= 0 && index < this.images.length) {
            this.selectedImageIndex = index;
        }else{
            this.selectedImage = false;
        }
    }
    selectImageByProperty(propertyName, propertyValue) {
        const foundImageIndex = this.images.findIndex(image => image[propertyName] === propertyValue);
        if (foundImageIndex !== -1) {
            this.selectedImageIndex = foundImageIndex;
            return true;
        }
        return false;
    }

    updateSelectedImageProperty(propertyName, propertyValue) {
        if (this.selectedImageIndex !== -1) {
            const selectedImage = this.images[this.selectedImageIndex];
            selectedImage[propertyName] = propertyValue;
            return true;
        }
        return false;
    }

    editAllImagesProperty(prop,value){
        for (var i = 0; i < this.images.length; i++) {
            this.images[i][prop] = value;
        }
    }

    imagesWithPropertyTrue(prop) {
        // por ejemplo, checked
        var ims = [];
        for (var i = 0; i < this.images.length; i++) {
            if (this.images[i][prop]) {
                ims.push(this.images[i]);
            }          
        }
        return ims;
    }
    imagesIndexesWithPropertyTrue(prop) {
        // por ejemplo, checked
        var indexes = [];
        for (var i = 0; i < this.images.length; i++) {
            if (this.images[i][prop]) {
                indexes.push(i);
            }
        }
        return indexes;
    }

    clearSelectedImage() {
        this.selectedImageIndex = -1;
    }
}